var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textRef",class:_vm.$style.component},[_c('ClockIcon',{class:_vm.$style.clockIcon,attrs:{"size":22,"color":"white"}}),_c('span',{attrs:{"Class":_vm.$style.text}},[_vm._v(" "+_vm._s(_vm.formatTime(_vm.time))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }